/**
 * 图片组件
 */
import { GUID, add_df_listen_scroll } from "@/utils";
import React, { HTMLAttributes, Key, memo, useEffect, useRef } from "react";
const logoIcon = require("./df_logo.png");
import "./index.less";
export interface DFImageProps extends HTMLAttributes<any> {
  src?: string | undefined | any;
  loadOrder?: number;
  onClick?: () => void;
}
const DFImage = (props: DFImageProps) => {
  const imgKey = GUID();
  const { src, loadOrder = 0, onClick } = props;
  const imageRef = useRef<any>();

  function isShowDom(element: any, img: any) {
    try {
      let item: any = img;
      var bound = item.getBoundingClientRect();
      var clientHeight = element?.offsetHeight || window.innerHeight;
      return bound.top + 10 <= clientHeight;
    } catch (e) {
      return true;
    }
  }

  const lazyLoad = (element: any, refDom?: any) => {
    const imgs: any = document.getElementsByClassName("df-images-load");
    for (let i = 0; i < imgs.length; i++) {
      const img = imgs[i];
      if (img.getAttribute("data-src-load")) return;
      if (!img.getAttribute("data-src-load") && isShowDom(element, img)) {
        const loadImageTime = setTimeout(() => {
          // img.src = img.getAttribute("data-src");
          const data_src = img.getAttribute("data-src");
          img.src =
            data_src.indexOf("http") > -1 || data_src.indexOf("base64") > -1
              ? data_src 
              : window.location.origin + "/" + data_src;
          img.setAttribute("data-src-load", true);
          img.className = img.className.replace("df-images-load", "df-images");
          clearTimeout(loadImageTime);
        }, loadOrder);
      } else {
        img.src = logoIcon.default;
      }
    }
    // if (refDom.current) {
    //   const img: any = refDom.current;
    //   if (!img.getAttribute("data-src-load") && isShowDom(element, img)) {
    //     const loadImageTime = setTimeout(() => {
    //       img.src = img.getAttribute("data-src");
    //       img.setAttribute("data-src-load", true);
    //       img.className = img.className.replace("df-images-load", "df-images");
    //       clearTimeout(loadImageTime);
    //     }, loadOrder);
    //   }
    // }
  };

  useEffect(() => {
    if (imageRef.current) {
      add_df_listen_scroll(lazyLoad, imageRef);
    }
  }, [imageRef]);

  useEffect(() => {
    lazyLoad(document.body);
  }, []);

  return (
    <>
      <img
        ref={(e) => {
          if (!imageRef.current) imageRef.current = e;
        }}
        src={src?.default || src || ""}
        className={`df-images df-images-load ${props.className || ""}`}
        data-src={src?.default || src || ""}
        onClick={onClick}
        onError={(e: any) => {
          e.target.onerror = null;
          e.target.src = logoIcon.default;
        }}
      />
    </>
  );
};

export default memo(DFImage);
